const DOWNLOAD_TYPE = {
  REQUEST_TYPE: { pdf: 'pdf', csv: 'csv' },
  RESPONSE_TYPE: { 'application/pdf': 'application/pdf', 'text/x-csv': 'text/x-csv' }
}

export default DOWNLOAD_TYPE
